import React from "react";
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import styles from "./Footer.module.css";

const demos = [
  // { label: "COQ9: Lipid Shuttle", href: "/demo/coq9" },
  // { label: "TMEM126A: Dual Function", href: "/demo/tmem" },
  // { label: "ANKZF1: Translation Stall", href: "/demo/ankzf1" },
  // { label: "PINK1-Parkin: Reporter Conflict", href: "/demo/pink1" },
  // { label: "mtDNA: Three Competing Models", href: "/demo/mtdna" },
  { label: "POLG Clinical — GPRA in Action", href: "/demo/polg-clinical" },
  { label: "KSS Clinical — GPRA", href: "/demo/kss-clinical" },
  { label: "MELAS Clinical — GPRA", href: "/demo/melas-clinical" },
  {
    label: "CPEO-plus — Scoring Under Uncertainty",
    href: "/demo/cpeo-clinical",
  },
];

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.brand}>
            <Link to="/" className={styles.logo}>
              <div className={styles.logoIcon}>
                <Zap className={styles.logoZap} />
              </div>
              <span className={styles.logoText}>
                Mito<span className={styles.logoHighlight}> Agent</span>
              </span>
            </Link>
            <p className={styles.tagline}>
              Genotype-to-Phenotype Reasoning Agent for Mitochondrial Disease.
            </p>
          </div>

          <div>
            <h4 className={styles.columnTitle}>Product</h4>
            <div className={styles.links}>
              <Link to="/playground" className={styles.link}>
                Playground
              </Link>
              <a href="#features" className={styles.link}>
                Features
              </a>
            </div>
          </div>

          <div>
            <h4 className={styles.columnTitle}>Research Sessions</h4>
            <div className={styles.links}>
              {demos.map((demo) => (
                <Link key={demo.label} to={demo.href} className={styles.link}>
                  {demo.label}
                </Link>
              ))}
            </div>
          </div>
        </div>{" "}
        {/* closes grid */}
        <div className={styles.bottom}>
          <p className={styles.copyright}>
            © 2026 MitoAgent. All rights reserved.
          </p>
          <p className={styles.location}>Stirling, Scotland</p>
          {/* <div className={styles.legal}>
            <span className={styles.legalText}>Privacy Policy</span>
            <span className={styles.legalText}>Terms of Service</span>
          </div>*/}
        </div>
      </div>{" "}
      {/* closes container */}
    </footer>
  );
}
